<template>
  <div class="reviews-page max-w-6xl mx-auto p-6 bg-gray-50 rounded-lg shadow-lg">
    <h1 class="text-2xl font-bold text-gray-800 text-center mb-6">Отзывы о врачах и медсестрах</h1>

    <!-- Filters Section -->
    <div class="filters flex justify-center gap-6 mb-6">
      <label class="text-sm font-medium text-gray-600">
        Тип:
        <select v-model="filters.provider_type" @change="applyFilters" class="ml-2 p-2 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none">
          <option value="">Все</option>
          <option value="Врач">Врач</option>
          <option value="Медсестра">Медсестра</option>
        </select>
      </label>

      <label class="text-sm font-medium text-gray-600">
        Оценка:
        <select v-model="filters.rating" @change="applyFilters" class="ml-2 p-2 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none">
          <option value="">Все</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
        </select>
      </label>
    </div>

    <!-- Reviews Table -->
    <div v-if="reviews.length" class="overflow-x-auto">
      <table class="min-w-full bg-white border border-gray-200 rounded-lg">
        <thead>
          <tr class="bg-gray-100 border-b">
            <th class="text-left p-4 font-medium text-gray-600">Мед. работник</th>
            <th class="text-left p-4 font-medium text-gray-600">Телефон мед. работника</th>
            <th class="text-left p-4 font-medium text-gray-600">Имя пациента</th>
            <th class="text-left p-4 font-medium text-gray-600">Телефон пациента</th>
            <th class="text-left p-4 font-medium text-gray-600">Оценка</th>
            <th class="text-left p-4 font-medium text-gray-600">Комментарий</th>
            <th class="text-left p-4 font-medium text-gray-600">Дата отзыва</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="review in reviews" :key="review.id" class="border-b hover:bg-gray-50">
            <td class="p-4 text-gray-700">{{ review.provider_name }} ({{ review.provider_type }})</td>
            <td class="p-4 text-gray-700">{{ review.provider_phone }}</td>
            <td class="p-4 text-gray-700">{{ review.patient_name }}</td>
            <td class="p-4 text-gray-700">{{ review.patient_phone }}</td>
            <td class="p-4 text-gray-700">{{ review.rating }}</td>
            <td class="p-4 text-gray-700">{{ review.comment }}</td>
            <td class="p-4 text-gray-500">{{ formattedDate(review.created_at) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="no-reviews text-center text-gray-500 text-lg p-4 bg-white border border-gray-200 rounded-lg">
      <p>Отзывов пока нет.</p>
    </div>
  </div>
</template>

<script>
import ReviewService from '@/services/reviewService.js';

export default {
  data() {
    return {
      reviews: [],
      filters: {
        provider_type: '',
        rating: '',
      },
    };
  },
  methods: {
    async loadReviews() {
      try {
        this.reviews = await ReviewService.getReviews(this.filters);
      } catch (error) {
        console.error("Error loading reviews:", error);
      }
    },
    applyFilters() {
      this.loadReviews();
    },
    formattedDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(date).toLocaleDateString('ru-RU', options);
    },
  },
  created() {
    this.loadReviews();
  }
};
</script>
